import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonRow,
  IonToolbar, ModalController
} from '@ionic/angular/standalone';
import { Store } from '@ngrx/store';
import { AppReleaseDto } from 'src/app/services/app-version.api.service';
import { visitAppStore } from 'src/app/store';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-app-update-modal',
  templateUrl: './app-update-modal.component.html',
  styleUrls: ['./app-update-modal.component.scss'],
  imports: [NgClass, IonHeader, IonToolbar, IonButtons, IonButton, IonContent, IonGrid, IonRow, IonCol, IonFooter]
})
export class AppUpdateModalComponent {
  @Input() forced: boolean;
  @Input() osSupported: boolean;
  @Input() latestRelease: AppReleaseDto;
  constructor(
    private modalController: ModalController,
    private store: Store
  ) {}

  onDismiss(): void {
    this.modalController.dismiss();
  }

  onUpdate(): void {
    this.store.dispatch(visitAppStore());
  }

  get appCurrentVersion(): string {
    return environment.versionName;
  }
}
